import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import CancellationPolicyDrawer from "components/drawer/CancellationPolicyDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

// internal imports

const CancellationPolicyTable = ({
  cancellationpolicy,
  perpage,
  currentPage,
  tab,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate, days, percentage } =
    useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <CancellationPolicyDrawer
          id={serviceId}
          data={cancellationpolicy}
          days={days}
          percentage={percentage}
          tab={tab}
        />
      </MainDrawer>

      <TableBody>
        {cancellationpolicy?.slice(0, perpage).map((data, index) => (
          <React.Fragment key={data.id}>
            {Object.entries(data.policy).map(
              ([key, value], cancellationpolicyndex) => {
                return (
                  <TableRow key={`${data.id}-${cancellationpolicyndex}`}>
                    {/* Row spanning logic for the first row only */}
                    {cancellationpolicyndex === 0 && (
                      <TableCell
                        className="text-center text-sm"
                        rowSpan={Object.keys(data.policy).length}
                      >
                        {(currentPage - 1) * perpage + index + 1}
                      </TableCell>
                    )}

                    {/* Policy key and value */}
                    <TableCell className="text-center text-sm">{key}</TableCell>
                    <TableCell className="text-center text-sm">
                      {value}%
                    </TableCell>

                    {cancellationpolicyndex === 0 && (
                      <TableCell
                        rowSpan={Object.keys(data.policy).length}
                        className="text-center text-sm"
                      >
                        <EditDeleteButton
                          title={`Cancellation Policy for ID ${data.type}`}
                          days={Object.keys(data.policy)[0]}
                          percentage={data.policy[Object.keys(data.policy)[0]]}
                          handleUpdate={handleUpdate}
                          handleModalOpen={handleModalOpen}
                          hideDelete={true}
                          hideEdit={hideEdit}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              }
            )}
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
};

export default CancellationPolicyTable;
